import React from "react";
import { shallowEqual } from "recompose";

const withReload = (propsMapper) => (BaseComponent) =>
  class extends React.Component {
    state = { key: 0 };
    computedProps =
      typeof propsMapper === "function" ? propsMapper(this.props) : null;

    reload = () => this.setState(({ key }) => ({ key: key + 1 }));

    componentWillReceiveProps = (nextProps) => {
      if (typeof propsMapper === "function") {
        const computedProps = this.computedProps;
        this.computedProps = propsMapper(nextProps);
        if (!shallowEqual(computedProps, this.computedProps)) {
          this.reload();
        }
      }
    };

    render = () => (
      <BaseComponent
        key={this.state.key}
        {...this.props}
        reload={this.reload}
      />
    );
  };

export default withReload;
